import { render, staticRenderFns } from "./FinancialValidationHeader.vue?vue&type=template&id=10fa5990&scoped=true"
import script from "./FinancialValidationHeader.vue?vue&type=script&lang=js"
export * from "./FinancialValidationHeader.vue?vue&type=script&lang=js"
import style0 from "./FinancialValidationHeader.vue?vue&type=style&index=0&id=10fa5990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fa5990",
  null
  
)

export default component.exports